import { urlBaseLeadCollector } from "../config";
import axiosInstance from "../../services/config/axiosinstance";

export default async function getConfigValues(
  eventId = '',
) {
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseLeadCollector}/adminPlusConfig/getConfigValues?adminPlusEventId=${eventId}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    let _return = {
      data: [],
      count: 0,
    }

    for (let i = 0; i < _ret.data?.data?.data?.length; i++) {
      _return.data.push(_ret.data?.data?.data[i]);
    }
    _return.count = _ret.data?.data?.data?.length;

    return _return;
  } catch (error) {
    console.log('Error getConfigValues', error);
    throw error;
  }
}
